import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { useLayoutEffect, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'; // import cx from 'classnames'

import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
var t = i18n.getFixedT(null, 'setting-mape');
var MapeGateChart = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      gateToAndFroMapeByWeek = _useSelector.mape.gateToAndFroMapeByWeek;

  var dispatch = useDispatch();
  var chartXY = useRef();
  var categoryAxis = useRef();

  var handleTimeText = function handleTimeText(time) {
    return (time < 10 ? '0' + time : time) + ':00';
  };

  var handleChartData = function handleChartData() {
    if (_.isEmpty(gateToAndFroMapeByWeek)) return [];
    var dayAryT = ['lbl-mon', 'lbl-tue', 'lbl-wed', 'lbl-thu', 'lbl-fri', 'lbl-sat', 'lbl-sun'];
    var chartData = [];
    gateToAndFroMapeByWeek.map(function (el) {
      var d = _.map(el.data, function (o) {
        return {
          category: dayAryT[el.day - 1] + '_' + o.time,
          day: t(dayAryT[el.day - 1]),
          time: o.time,
          mape: Math.round(o.mape * 100 * 10) / 10,
          avgDuration: o.avgDuration,
          avgEstVisitDuration: o.avgEstVisitDuration,
          avgVehicleVolumes: o.avgVehicleVolumes
        };
      });

      chartData = [].concat(_toConsumableArray(chartData), _toConsumableArray(d)); // Create x-axis range

      var range = categoryAxis.current.axisRanges.create();
      range.category = d[0].category;
      range.endCategory = d[d.length - 1].category;
      range.label.text = d[0].day;
      range.label.dy = 30; // Control range label position y-axis

      range.label.truncate = true;
      range.label.fontWeight = 'bold';
      range.label.tooltipText = d[0].day;
      range.label.adapter.add("maxWidth", function (maxWidth, target) {
        var range = target.dataItem;
        var startPosition = categoryAxis.current.categoryToPosition(range.category, 0);
        var endPosition = categoryAxis.current.categoryToPosition(range.endCategory, 1);
        var startX = categoryAxis.current.positionToCoordinate(startPosition);
        var endX = categoryAxis.current.positionToCoordinate(endPosition);
        return endX - startX;
      });
    });
    return chartData;
  };

  useLayoutEffect(function () {
    chartXY.current = am4core.create('mape-gate-chart', am4charts.XYChart);
    chartXY.current.hiddenState.properties.opacity = 0; // this creates initial fade-in

    chartXY.current.leftAxesContainer.layout = 'vertical';
    chartXY.current.rightAxesContainer.layout = 'vertical'; // Create axes

    categoryAxis.current = chartXY.current.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.current.dataFields.category = 'category';
    categoryAxis.current.dataItems.template.text = '{time}';
    categoryAxis.current.renderer.grid.template.location = 0;
    categoryAxis.current.renderer.minGridDistance = 18;
    categoryAxis.current.adapter.add("tooltipText", function (tooltipText, target) {
      return categoryAxis.current.tooltipDataItem.dataContext.day + ' ' + handleTimeText(categoryAxis.current.tooltipDataItem.dataContext.time);
    }); // categoryAxis.current.renderer.cellStartLocation = 0.2
    // categoryAxis.current.renderer.cellEndLocation = 0.8
    // Set Chart 1 yAxes (left - top)

    var valueAxis_lt = chartXY.current.yAxes.push(new am4charts.ValueAxis());
    valueAxis_lt.title.text = t('lbl-gate-toandfro-time');
    valueAxis_lt.height = am4core.percent(50);
    valueAxis_lt.renderer.minGridDistance = 50;
    valueAxis_lt.min = 0;
    var series_lt = chartXY.current.series.push(new am4charts.LineSeries());
    series_lt.dataFields.categoryX = 'category';
    series_lt.dataFields.valueY = 'avgDuration';
    series_lt.tooltipText = "".concat(t('lbl-real-value'), ":{valueY}");
    series_lt.strokeWidth = 2;
    var series2_lt = chartXY.current.series.push(new am4charts.LineSeries());
    series2_lt.dataFields.categoryX = 'category';
    series2_lt.dataFields.valueY = 'avgEstVisitDuration';
    series2_lt.tooltipText = "".concat(t('lbl-predicted-value'), ":{valueY}");
    series2_lt.strokeWidth = 2; // Set Chart 2 yAxes (left - bottom)

    var valueAxis_lb = chartXY.current.yAxes.push(new am4charts.ValueAxis());
    valueAxis_lb.height = am4core.percent(50);
    valueAxis_lb.title.text = t('lbl-mape-percent');
    valueAxis_lb.marginTop = 30;
    valueAxis_lb.min = 0;
    var series_lb = chartXY.current.series.push(new am4charts.ColumnSeries());
    series_lb.dataFields.categoryX = 'category';
    series_lb.dataFields.valueY = 'mape';
    series_lb.yAxis = valueAxis_lb;
    series_lb.columns.template.strokeOpacity = 0;
    series_lb.columns.template.tooltipText = "MAPE:{valueY}%";
    series_lb.columns.template.adapter.add("fill", function (fill, target) {
      if (target.dataItem && target.dataItem.valueY >= 34 && target.dataItem.valueY < 67) return am4core.color('#ffbc3c');else if (target.dataItem && target.dataItem.valueY >= 67) return am4core.color('#ff3c3c');else return am4core.color('#55c836');
    }); // Set Chart 3 yAxes (right - bottom)

    var valueAxis_rb = chartXY.current.yAxes.push(new am4charts.ValueAxis());
    valueAxis_rb.renderer.opposite = true;
    valueAxis_rb.marginTop = 30;
    valueAxis_rb.title.text = t('lbl-car-count');
    valueAxis_rb.min = 0;
    var series_rb = chartXY.current.series.push(new am4charts.LineSeries());
    series_rb.dataFields.categoryX = 'category';
    series_rb.dataFields.valueY = 'avgVehicleVolumes';
    series_rb.yAxis = valueAxis_rb;
    series_rb.tooltipText = '車輛數:{valueY}';
    series_rb.strokeWidth = 2; // Set Chart 4 yAxes (right - top)

    var valueAxis_rt = chartXY.current.yAxes.push(new am4charts.ValueAxis());
    valueAxis_rt.renderer.opposite = true;
    valueAxis_rt.renderer.labels.template.fontSize = 0;
    valueAxis_rt.renderer.minGridDistance = 50;
    valueAxis_rt.min = 0;
    var series_rt = chartXY.current.series.push(new am4charts.LineSeries());
    series_rt.dataFields.categoryX = 'category';
    series_rt.dataFields.valueY = 'avgDuration';
    series_rt.yAxis = valueAxis_rt;
    series_rt.strokeWidth = 0; // // range grid
    // var rangeTemplate = categoryAxis.current.axisRanges.template;
    // rangeTemplate.tick.disabled = false;
    // rangeTemplate.tick.location = 0;
    // rangeTemplate.tick.strokeOpacity = 1;
    // rangeTemplate.tick.length = 5;
    // rangeTemplate.grid.strokeOpacity = 0.2;
    // rangeTemplate.label.tooltip = new am4core.Tooltip();
    // rangeTemplate.label.tooltip.dy = -10;
    // rangeTemplate.label.cloneTooltip = false;
    // const dayAryT = ['lbl-mon', 'lbl-tue', 'lbl-wed', 'lbl-thu', 'lbl-fri', 'lbl-sat', 'lbl-sun']
    // let chartData = []
    // data.map(el => {
    //     let d = _.map(el.data, o => ({
    //             category: dayAryT[el.day - 1] + '_' + o.time,
    //             day: t(dayAryT[el.day - 1]),
    //             time: o.time,
    //             mape: o.mape,
    //             avgDuration: o.avgDuration,
    //             avgEstVisitDuration: o.avgEstVisitDuration
    //         })
    //     )
    //     chartData = [ ...chartData, ...d]
    //     // Create x-axis range
    //     let range = categoryAxis.current.axisRanges.create()
    //     range.category = d[0].category
    //     range.endCategory = d[d.length - 1].category
    //     range.label.text = d[0].day
    //     range.label.dy = 30 // Control range label position y-axis
    //     range.label.truncate = true
    //     range.label.fontWeight = 'bold'
    //     range.label.tooltipText = d[0].day
    //     range.label.adapter.add("maxWidth", (maxWidth, target) => {
    //         let range = target.dataItem
    //         let startPosition = categoryAxis.current.categoryToPosition(range.category, 0)
    //         let endPosition = categoryAxis.current.categoryToPosition(range.endCategory, 1)
    //         let startX = categoryAxis.current.positionToCoordinate(startPosition)
    //         let endX = categoryAxis.current.positionToCoordinate(endPosition)
    //         return endX - startX
    //     })
    // })

    chartXY.current.cursor = new am4charts.XYCursor(); // chartXY.current.data = chartData
    // Hide amcharts4 logo

    var eles = document.querySelectorAll('[aria-labelledby$=-title]');
    eles.forEach(function (ele) {
      ele.style.visibility = 'hidden';
    });
    return function () {
      chartXY.current.dispose();
    };
  }, []);
  useEffect(function () {
    chartXY.current.data = handleChartData();
  }, [JSON.stringify(gateToAndFroMapeByWeek)]);
  return /*#__PURE__*/React.createElement("div", {
    id: "mape-gate-chart",
    className: "chart"
  });
});
export default MapeGateChart;